import $ from 'jquery';
import { uploadUri } from '../appConfig';

const generateRoomWrapper = (data) => {
	const template = $('._template-block > .room-wrapper').clone();
	template.find('._link-flag').attr('id', `${data.id}`);
	template.find('.roomname').text(data.name);
	template.find('.bed').text(data.bed);
	template.find('.feature').append(data.feature);
	template.find('.facility').append(data.facility);
	template.find('.bathroom').append(data.bathroom);
	template.find('.size').append(data.size);
	template.find('.number').append(data.number);

	let swiperHtml = '';
	data.images.forEach((imagePath) => {
		swiperHtml += `<div class='swiper-slide' \
			style='background-image: url(${uploadUri}/${imagePath})'></div>`;
	});
	template.find('.swiper-wrapper').html(swiperHtml);

	return template.prop('outerHTML');
};

export default generateRoomWrapper;



// WEBPACK FOOTER //
// ./src/js/room/generateRoomWrapper.js